import script from "./AccountAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountAdmin.vue?vue&type=script&setup=true&lang=ts"

import "./AccountAdmin.vue?vue&type=style&index=0&id=1562081c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1562081c"]])

export default __exports__